import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslationModuleEnum } from 'src/app/utils/translation-modules.enum';

@Component({
  selector: "app-radio-box",
  templateUrl: "./radio-box.component.html",
  styleUrls: ["./radio-box.component.scss"],
})
export class RadioBoxComponent implements OnInit {
  translationModulesEnum = TranslationModuleEnum;
  @Input() set active(value: boolean) {
    this.checked = value;
  }
  @Input() value: string = "";
  @Output() emitValue: EventEmitter<any> = new EventEmitter();
  id = Math.random();
  checked: boolean = false;
  @Input() disabled: boolean = false;

  constructor() {}

  ngOnInit(): void {}
  emitCheckedValue() {
    if (!this.disabled) {
      this.emitValue.emit(this.value);
    }
  }
}
